
define('jsx!components/shared/login-image-picker',['react', 'constants/login-images'], function(React, LoginImages) {
    return React.createClass({
        displayName: "LoginImagePicker",
        getDefaultProps: function ()
        {
            return {
                "disabled": false,
                "max_selection": 2,
                "selected_images": [],
                "onChange": function (newSelectedImages) {
                    console.log("New Selected Images", newSelectedImages);
                }
            }
        },
        getInitialState: function ()
        {
            return {
                "selected_images": this.props.selected_images || []
            };
        },
        findSelectedImageIndex: function (image)
        {
            // An image is defined as selected if the title and src
            // match that of the input object.
            for (var i = 0; i < this.state.selected_images.length; i++) {
                var selected = this.state.selected_images[i];
                if (selected.title === image.title && selected.src === image.src) {
                    return i;
                }
            }

            return -1;
        },
        didClickImage: function (image)
        {
            if (this.props.disabled) {
                return;
            }

            var selectedImageIndex = this.findSelectedImageIndex(image);
            var newSelectedImages = this.state.selected_images.slice();

            // If the image is selected, remove it from the array.
            // If it is not selected, push it to the array.
            if (selectedImageIndex > -1) {
                newSelectedImages.splice(selectedImageIndex, 1);
            } else {
                if (newSelectedImages.length < this.props.max_selection) {
                    newSelectedImages.push(image);
                }
            }

            this.setState({ "selected_images": newSelectedImages });
        },
        componentWillReceiveProps: function (nextProps)
        {
            this.setState({ selected_images: nextProps.selected_images });
        },
        componentWillUpdate: function (nextProps, nextState)
        {
            if (!(nextState.selected_images == this.state.selected_images)) {
                this.props.onChange(nextState.selected_images);
            }
        },
        renderImage: function (image)
        {
            var self = this;
            var classNames = "grid-element";
            var selectedImageIndex = this.findSelectedImageIndex(image);
            // If selected, add the appropriate CSS class.
            if (selectedImageIndex > -1) {
                classNames += " selected";
            }

            // If not selected and we have reached the max, disable this image.
            if (selectedImageIndex == -1 && this.state.selected_images.length >= this.props.max_selection) {
                classNames += " disabled";
            }

            return (
                React.createElement("div", {
                key:  image.title, 
                className:  classNames, 
                onClick:  function() {
                    self.didClickImage(image);
                }}, 
                    React.createElement("div", {className: "wrapper"}, 
                        React.createElement("div", {className: "content"}, 
                            React.createElement("img", {src:  image.src, title:  image.title, alt:  image.title, width: "100%"})
                        )
                    )
                )
            )
        },
        render: function()
        {
            var self = this;

            return (
                React.createElement("div", {className: "auth-image-picker grid"}, 
                     LoginImages.map(this.renderImage, this) 
                )
            )
        }
    })
});
